/**
 * Tasks teaching copy. Hardcoded system text. Do not paraphrase.
 * Spec: docs/path/path-spec.md
 * Writer-facing room name is Tasks. Writer-facing Plot card name is Logline.
 */

import {
  BOOK_NOTES,
  OPEN_DOCS,
  PATH_GAPS_EMPTY as PATH_GAPS_EMPTY_COPY,
  PATH_SERIES_DOCS_ONLY,
  PATH_CHAT,
  PATH_CHAT_OR_DOCS,
  PATH_TALK_OR_DOCS,
  PATH_TEACH_CHAT,
  PATH_TEACH_CHAT_OR_DOCS,
  PATH_TEACH_PEOPLE,
  PATH_TEACH_PLOT,
  PATH_TEACH_TALK_OR_DOCS,
} from '../utils/writerCopy';

export const PATH_HEADER = 'Do this next';

export const PATH_ALL_PRESENT = (
  'You have the ingredients the shipped generate doors read. Generate still proposes. Review still decides whether it matches the book you want.'
);

export const PATH_SERIES_NOTES_ONLY = PATH_SERIES_DOCS_ONLY;

export const PATH_ROW_IDS = [
  'talk_or_notes',
  'theme',
  'people_and_places',
  'plot_dossier',
  'plot_theme',
  'outline',
  'scene_prose',
];

export const PATH_TALK_OR_NOTES_NAMES = {
  fresh: PATH_CHAT,
  documents: PATH_CHAT_OR_DOCS,
};

export const PATH_TALK_OR_NOTES_TEACHING = {
  fresh: PATH_TEACH_CHAT,
  documents: PATH_TEACH_CHAT_OR_DOCS,
};

export const PATH_ROW_NAMES = {
  talk_or_notes: PATH_TALK_OR_DOCS,
  theme: 'Theme',
  people_and_places: 'People and places',
  plot_dossier: 'Plot Dossier',
  plot_theme: 'Logline',
  outline: 'Outline',
  scene_prose: 'Scene prose',
};

export const PATH_TEACHING_LINES = {
  talk_or_notes: PATH_TEACH_TALK_OR_DOCS,
  theme: 'Theme is the abstract sentence the story is about beneath its events. Logline cannot be written without it.',
  people_and_places: PATH_TEACH_PEOPLE,
  plot_dossier: PATH_TEACH_PLOT,
  plot_theme: 'Logline is the central conflict in action — more concrete than Theme, less concrete than a plot summary.',
  outline: 'Plot Grid is the thread-by-scene grid. Opening it maps what this book already has. Generate is a separate step. It may invent placements. You edit cells.',
  scene_prose: 'Prose drafts one scene from that column, then shows a receipt. Presence is not a quality check.',
};

export const PATH_STATE_LABELS = {
  present: 'Present',
  missing: 'Missing',
  will_invent: 'Will invent',
  later: 'Later',
};

export const PATH_ACTION_LABELS = {
  notes: OPEN_DOCS,
  discovery: 'Open Discovery',
  book_cards_theme: 'Open Theme',
  book_cards: `Open ${BOOK_NOTES}`,
  plot_writeup: 'Open Plot Workshop',
  choose_framework: 'Choose a Framework',
  book_cards_plot_theme: 'Open Logline',
  plottrack: 'Open Plot Grid',
  bring_into_book: 'Bring into this book',
  scene_writing: 'Continue drafting',
  continue_draft: 'Continue drafting',
  review_draft: 'Review draft',
};

export const PATH_GAPS_CONTROL = 'Ask what to work on next';
export const PATH_GAPS_EMPTY = PATH_GAPS_EMPTY_COPY;
export const PATH_GAPS_ACTION = 'Chat about this';
